var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',_vm._l((_vm.chirps),function(chirp){return _c('b-col',{key:chirp.id,attrs:{"cols":"12","md":"6","lg":"4"}},[_c('chirp-card',{staticClass:"chirpCard",attrs:{"chirp":chirp}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }